/**
 * Start page configuration for the onboarding flow.
 *
 * @module onboarding/start-page
 */

import type { applicant } from '@noxverify/api-contracts';

type CaseType = applicant.CaseType;

export const PAGE_KEY = 'start' as const;

export interface StartPageProps {
  projectSlug: string;
  jurisdictionId: string;
  workflowTemplateId: string | null;
}

/**
 * Determine which case types to offer based on the workflow template.
 *
 * When no workflow template is configured the portal defaults to
 * `kyc_individual` only. Future implementations will inspect the
 * template to unlock additional case types.
 */
export function getAvailableCaseTypes(
  workflowTemplateId: string | null,
): CaseType[] {
  // Default: KYC individual only
  if (!workflowTemplateId) return ['kyc_individual'];

  // Will be expanded based on workflow template configuration
  return ['kyc_individual'];
}
